import { apiSlice } from './apiSlice';
import type { User, AuthTokens } from '@/types';

/* ---------- TYPES ---------- */

export interface LoginResponse {
  message: string;
  user: User;
}

export interface ApiResponse<T> {
  data: T;
  message?: string;
}

interface LoginCredentials {
  email: string;
  password: string;
}

interface RegisterData {
  email: string;
  password: string;
  name: string;
}
export interface ChangePasswordRequest {
  oldPassword: string;
  newPassword: string;
}

export interface ChangePasswordResponse {
  message: string;
}

// Mock flag - set to true to use mock responses for login
// const isMock = true;
/* API */

export const authApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation<LoginResponse, LoginCredentials>({
      query: (credentials) => ({
        url: '/auth/login',
        method: 'POST',
        body: credentials,
        credentials: 'include',
      }),
      transformResponse: (response: any) => ({
        message: response.message,
        user: response.user,
      }),
      invalidatesTags: ['Auth'],
    }),
    // login: builder.mutation<LoginResponse, LoginCredentials>({
    //   async queryFn(credentials) {
    //     if (isMock) {
    //       return {
    //         data: {
    //           accessToken: 'mock-token',
    //           type: 'Bearer',
    //         },
    //       };
    //     }

    //     return {
    //       error: { status: 500, data: 'API not configured' },
    //     };
    //   },
    // }),

    register: builder.mutation<ApiResponse<{ user: User; tokens: AuthTokens }>, RegisterData>({
      query: (userData) => ({
        url: '/auth/register',
        method: 'POST',
        body: userData,
      }),
      invalidatesTags: ['Auth'],
    }),

    logout: builder.mutation<ApiResponse<null>, void>({
      query: () => ({
        url: '/auth/logout',
        method: 'POST',
      }),
      invalidatesTags: ['Auth'],
    }),

    refreshToken: builder.mutation<ApiResponse<AuthTokens>, { refreshToken: string }>({
      query: ({ refreshToken }) => ({
        url: '/auth/refresh',
        method: 'POST',
        body: { refreshToken },
      }),
    }),

    /* ---------- GET CURRENT USER ---------- */
    getCurrentUser: builder.query<ApiResponse<User>, void>({
      query: () => ({
        url: '/users/me',
        method: 'GET',
      }),
      providesTags: ['Auth'],
    }),

    changePassword: builder.mutation<ChangePasswordResponse, ChangePasswordRequest>({
      query: (body) => ({
        url: '/admin/change-password',
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['Auth'],
    }),
  }),
});

/* ---------- HOOKS ---------- */

export const {
  useLoginMutation,
  useRegisterMutation,
  useLogoutMutation,
  useRefreshTokenMutation,
  useGetCurrentUserQuery,
  useChangePasswordMutation,
} = authApi;
